import React, { Component, Fragment } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Proptypes from "prop-types";
import MyButton from "../../util/MyButton";
// MUI
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
// ICONS
import DeleteOutline from "@material-ui/icons/DeleteOutline";
// redux
import { connect } from "react-redux";
import { deleteScream } from "../../redux/actions/dataActions";

const styles = {
  deleteButton: {
    position: "absolute",
    left: "90%",
    top: "10%"
  }
};

class DeleteScream extends Component {
  state = {
    open: false
  };

  handleOpen = () => {
    this.setState({
      open: true
    });
  };

  handleClose = () => {
    this.setState({
      open: false
    });
  };

  deleteScream = () => {
    this.props.deleteScream(this.props.screamId);
    this.setState({ open: false });
  };

  render() {
    const { classes } = this.props;

    return (
      <Fragment>
        <MyButton
          tip="DeleteScream"
          onClick={this.handleOpen}
          btnClassname={classes.deleteButton}
        >
          <DeleteOutline color="secondary" />
        </MyButton>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>
            {" "}
            Are you sure you want to delete this scream?{" "}
          </DialogTitle>
          <DialogActions>
            <Button onClick={this.deleteScream} color="secondary">
              Delete
            </Button>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

DeleteScream.propTypes = {
  deleteScream: Proptypes.func.isRequired,
  classes: Proptypes.object.isRequired,
  screamId: Proptypes.string.isRequired
};

const mapActionToProps = {
  deleteScream
};

export default connect(
  null,
  mapActionToProps
)(withStyles(styles)(DeleteScream));
